import { Navigate } from 'react-router-dom';
import { getUser, isAuthenticated } from '@/Services/localStorageUtility';

const ProtectedRoute = ({ children, roles }) => {
  const currentUser = getUser();
  if (!isAuthenticated() || (roles && !roles.includes(currentUser?.roleData?.type))) {
    return <Navigate to="/error/403" replace />;
  }
  return children;
};

export default ProtectedRoute;